import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import BasicTextArea from '../../../../../shared/components/formComponents/groups/BasicTextArea';
import ImageUpload from '../../../../../shared/components/formComponents/inputs/ImageUpload';

class OnscreenSectionItem extends Component {
    static propTypes = {
        memberReference: PropTypes.string
    };

    render() {
        const { memberReference } = this.props;

        return (
            <div className={'emailSectionItem col-12'}>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.title` : 'content.title'}
                        label={'Title'}
                        className={'col-4'}
                        component={BasicText}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.buttonText` : 'content.buttonText'}
                        label={'CTA Button Text'}
                        className={'col-2'}
                        component={BasicText}
                    />
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.imageUrl` : 'content.imageUrl'}
                        label={'Image'}
                        className={'col-12 col-sm-4'}
                        cropProp={{ width: 150, height: 150, type: 'square' }}
                        component={ImageUpload}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.body` : 'content.body'}
                        label={'Body'}
                        className={'col-12 col-sm-4'}
                        component={BasicTextArea}
                    />
                </div>
            </div>
        );
    }
}

export default OnscreenSectionItem;
